/**
 * 需要弹窗的接口
 */
export var teamFieldWindow = {
  '/api/atlas/plans|POST': {
    entitySrc: 'fe',
    entityKey: 'requirementIds',
    entityType: 'split',
    eventId: 'CREATE_TEST_PLAN'
  },
  '/api/atlas/plans|PUT': {
    entitySrc: 'fe',
    entityKey: 'requirementIds',
    entityType: 'split',
    eventId: 'RELATE_TEST_CASE'
  },
  '/api/atlas/plans/review/status|POST': {
    entitySrc: 'fe_scene',
    paramsEntityKey: 'reviewStatus',
    paramsEntityKeyMap: {
      1: {
        eventId: 'START_PLAN_REVIEW'
      },
      2: {
        eventId: 'PLAN_REVIEW_PASSED'
      }
    }
  }
};